import React from 'react';
import './styles.scss';


const Button =({name}) => {

    return (
        <button
        type='submit'
        className='Button'>
            {name}
        </button>


    )




}

export default Button;